import { isPlainObject } from 'lodash';
import workOrderTypes from '@/utilities/enums/workOrderTypes';

const defaultState = () => ({
    workOrder: {},
    analysisRequestsList: [],
    workOrderType: workOrderTypes.VISIT,
    workOrderLabInfo: {
        site: '',
        client: '',
        preSelectedSamples: [],
    },
});

const mutations = {
    setWorkOrderState(state, workOrder) {
        state.workOrder = workOrder;
    },
    resetWorkOrderState(state) {
        Object.assign(state, defaultState());
    },
    setWorkOrderAnalysisRequestsState(state, analysisRequests) {
        state.analysisRequestsList = analysisRequests;
    },
    resetWorkOrderAnalysisRequestsState(state) {
        state.analysisRequestsList = [];
    },
    setWorkOrderType(state, type) {
        state.workOrderType = type;
    },
    setWorkOrderLabInfo(state, workOrderLabInfo) {
        state.workOrderLabInfo = workOrderLabInfo;
    },
    /**
     * @param {Object} state
     * @param {Object} payload
     */
    updateSummaryReport(state, payload) {
        const { workOrder } = state;
        const summaryReport = isPlainObject(workOrder.summaryReport) ? workOrder.summaryReport : {};

        state.workOrder.summaryReport = {
            ...summaryReport,
            ...payload,
        };
    },
};

const actions = {
    async getWorkOrderInfo({ commit, dispatch }, workOrderId) {
        try {
            const { data } = await this.$rq.getWorkOrder(workOrderId);
            commit('setWorkOrderState', data);
            dispatch('getWorkOrderAnalysisRequests', workOrderId);
        } catch (err) {
            dispatch('resetWorkOrderInfo');
        }
    },
    async getWorkOrderAnalysisRequests({ commit, dispatch }, workOrderId) {
        try {
            const queryParams = {
                workOrder: workOrderId,
                perpage: 100,
            };
            const { data } = await this.$rq.getAnalysisRequests(queryParams);
            commit('setWorkOrderAnalysisRequestsState', data.analysisRequests);
        } catch (err) {
            dispatch('resetWorkOrderAnalysisRequests');
        }
    },
    setWorkOrderType({ commit }, type) {
        commit('setWorkOrderType', type);
    },
    setWorkOrderLabInfo({ commit }, workOrderLabInfo) {
        commit('setWorkOrderLabInfo', workOrderLabInfo);
    },
    resetWorkOrderInfo({ commit }) {
        commit('resetWorkOrderState');
    },
    resetWorkOrderAnalysisRequests({ commit }) {
        commit('resetWorkOrderAnalysisRequestsState');
    },
};

const findNode = (tree = [], ref) => {
    const response = tree.map(node => (node.ref === ref ? node : findNode(node.children, ref)));
    return response.find(a => a || null);
};

const getters = {
    workOrder: state => state.workOrder,
    analysisRequestsList: state => state.analysisRequestsList,
    workOrderType: state => state.workOrderType,
    workOrderLabInfo: state => state.workOrderLabInfo,
    analysisView: state => {
        const { tree, analysisTypes, tasks } = state.workOrder.activities.measuresAndSamplesCollect;
        const analysisView = {};

        tasks.analyses.forEach(analysis => {
            const analysisType = analysisTypes.find(({ ref }) => ref === analysis.analysisType.ref);
            const id = analysis.analysisType.ref;
            const component = findNode(tree, analysis.source.ref);

            if (!analysisView[id]) {
                analysisView[id] = {};
                analysisView[id].analysisType = analysisType;
            }

            if (!analysisView[id].analyses) {
                analysisView[id].analyses = [];
            }

            analysisView[id].analyses.push({
                ...analysis,
                analysisType,
                component,
            });
        });

        return analysisView;
    },
    /**
     * @param {Object} state
     * @return {Object}
     */
    summaryReport: state => {
        const { summaryReport } = state.workOrder;

        return isPlainObject(summaryReport) ? summaryReport : {};
    },
};

const state = defaultState();

export default {
    state,
    getters,
    actions,
    mutations,
};
